import { call, put, select } from 'redux-saga/effects'

import Account from 'common/modules/account'
import Internal from 'common/modules/internal'
import { LAUNCHER_TAG } from 'common/tags'
import { creators } from 'common/modules/arbiter/actions'
import Loader from 'common/modules/loader'
import Lifecycle from 'common/modules/lifecycle'

import {
    focusMenu,
    focusPrompt,
    focusLauncher,
} from 'common/modules/arbiter/sagas/frameUtilities'

import awaitWizard from 'common/awaitWizard'

export default function* watchDirectLinks(params = {}) {
    const { link, queryString = {} } = params
    const loader = yield select(Loader?.selectors?.loader)

    if (!loader.guest && !loader.user) {
        return null
    }

    const monetizationTypeIsDonation = yield select(Loader.selectors.monetizationTypeIsDonation)
    const userStatus = yield select(Loader.selectors.userStatus)
    const isLoggedIn = !!loader.user
    const userFirstName = yield select(Loader.selectors.userFirstName)
    const isPaying = userStatus === 'paying'

    switch (link) {
        case 'manage_account':
            yield put(creators.showChild({ frame: LAUNCHER_TAG }))
            yield call(awaitWizard.login)
            yield focusMenu('/')

            break

        case 'edit_profile':
            yield call(awaitWizard.login)
            yield focusMenu('/editProfile')

            break

        case 'manage_newsletters':
            yield call(awaitWizard.login)
            yield focusMenu('/manageNewsletters')

            break

        case 'manage_payment':
            yield call(awaitWizard.login)
            if (!isPaying) {
                yield focusMenu('/')
            } else {
                yield focusMenu('/managePlan')
            }

            break
        case 'pay':
        case 'checkout':
            if (!isPaying) {
                if (monetizationTypeIsDonation) {
                    yield focusPrompt('/donate')
                } else {
                    yield focusPrompt('/checkout')
                }
            } else {
                yield focusMenu('/managePlan')
            }

            break

        case 'registration':
            yield focusPrompt('/registration')
            break

        case 'donate':
            yield focusPrompt('/donate')
            break

        case 'gift':
            yield focusPrompt('/gift')
            break

        case 'login':
            if (!isLoggedIn) {
                yield focusPrompt('/registration')
            } else {
                yield put(creators.showChild({ frame: LAUNCHER_TAG }))
                yield focusMenu('/')
            }
            break

        case 'redeem_gift':
            yield focusPrompt('/redeem-gift', queryString)
            break

        case 'reset_password':
            yield put(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_prompt',
                    ...Account.creators.hasPasswordResetAuth(),
                },
            }))

            yield focusPrompt('/account/edit-password')
            break

        case 'emailLinkExpiration':
            yield focusPrompt('/login/token')
            break

        case 'verified':
            if (isLoggedIn) {
                yield focusMenu('/notification', {
                    text: 'Your account is now verified.',
                    backRoute: '/',
                })
            } else {
                yield focusLauncher()
            }
            break

        case 'login_link':
            if (isLoggedIn) {
                yield focusMenu('/notification', {
                    text: (
                        userFirstName
                            ? `Welcome back, ${userFirstName}!`
                            : 'Welcome back!'
                    ),
                    backRoute: '/',
                })
                yield put(Lifecycle.creators.userAuthenticated())
            } else {
                yield focusLauncher()
            }
            break

        default:
            if (isLoggedIn) {
                yield focusMenu('/')
            } else {
                yield focusLauncher()
            }
    }

    return null
}
